import { isNullOrUndefined } from "../../../../../ceres/helper/utils";

const NotificationService = require("../../../../../ceres/services/NotificationService");

import ValidationService from "../../../../../ceres/services/ValidationService";
import TranslationService from "../../../../../ceres/services/TranslationService";
import Vue from "vue";
import AddressInputGroup from "../../AddressInputGroup.vue";

export default Vue.component("create-update-address", {
	components: {
		AddressInputGroup
	},

	props: {
		addressData: {
			type: Object,
			default() {
				return {};
			}
		},
		addressModal: {
			type: Object,
			default() {
				return {};
			}
		},
		modalType: String,
		addressType: String,
		template: String,
		optionalAddressFields: {
			type: Object,
			default: () => {
				return {};
			}
		},
		requiredAddressFields: {
			type: Object,
			default: () => {
				return {};
			}
		},
		defaultSalutation: {
			type: String,
			default: "male"
		},
		showRegisterOption: {
			type: Boolean,
			default: false
		},
		showLoginOption: {
			type: Boolean,
			default: false
		},
		showExpressButtons: {
			type: Boolean,
			default: false
		},
		favCountries: {
			type: Array,
			default: () => []
		},
		alternateTranslations: {
			type: Object,
			default: () => {
				return {};
			}
		},
		fieldsByCountry: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},

	data() {
		return {
			waiting: false,
			showRegisterInput: false,
			isValid: false
		};
	},

	computed: {
		addressList() {
			return this.$store.getters.getAddressList(this.addressType);
		}
	},

	addressInputGroupMethods: {
		sendValidAddressToRegister: () => {}
	},

	methods: {
		/**
		 * Validate the address fields
		 */
		validate(dontSave = false) {
			if (!this.validateBirthday(this.addressData)) {
				this.emitInputEvent({
					field: "birthday",
					value: null
				});

				NotificationService.warn(
					TranslationService.translate("Ceres::Template.checkoutAddressNoValidBirthdate")
				);
			}

			Vue.nextTick(() => {
				ValidationService.validate(this.$refs.addressForm)
					.done(() => {
						const vatNumberModel = $(this.$refs.addressForm).find("[data-model='vatNumber']");
						const vatNumber = vatNumberModel
							.children()
							.first()
							.val();
						const vatValidateRegEx = /^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}L|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]S[0-9]{5}L|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})$/g;
						const vatValidateRegEx2 = /^[A-Z]{2}.*/g;

						if (typeof vatNumber !== "undefined") {
							vatNumberModel.removeClass("error");
						}
						if (typeof vatNumber !== "undefined" && vatNumber !== "") {
							if (
								vatNumber.match(vatValidateRegEx) !== null &&
								vatNumber.match(vatValidateRegEx2) !== null
							) {
								if (dontSave) {
									this.isValid = true;
									this.$options.addressInputGroupMethods.sendValidAddressToRegister(this.addressData);
								} else {
									this.saveAddress();
								}
							} else {
								vatNumberModel.addClass("error");
								NotificationService.error(
									TranslationService.translate("Ceres::Template.errorVatNumberValidation")
								);
							}
						} else if (dontSave) {
							this.isValid = true;
							this.$options.addressInputGroupMethods.sendValidAddressToRegister(this.addressData);
						} else {
							this.saveAddress();
						}
					})
					.fail(invalidFields => {
						const fieldNames = [];

						this.isValid = false;
						for (const field of invalidFields) {
							let fieldName = field.lastElementChild.innerHTML.trim();

							fieldName =
								fieldName.slice(-1) === "*" ? fieldName.slice(0, fieldName.length - 1) : fieldName;
							fieldNames.push(fieldName);
						}

						ValidationService.markInvalidFields(invalidFields, "error");
						NotificationService.error(
							TranslationService.translate("Ceres::Template.checkoutCheckAddressFormFields", {
								fields: fieldNames.join(", ")
							})
						);
					});
			});
		},

		/**
		 * Save the new address or update an existing one
		 */
		saveAddress() {
			if (this.modalType === "initial" || this.modalType === "create") {
				this.createAddress();
			} else if (this.modalType === "update") {
				this.updateAddress();
			}
		},

		/**
		 * Update an address
		 */
		updateAddress() {
			this.waiting = true;
			this._syncOptionTypesAddressData();

			this.$store.dispatch("updateAddress", { address: this.addressData, addressType: this.addressType }).then(
				() => {
					this.addressModal.hide();
					this.waiting = false;
				},
				error => {
					this.waiting = false;

					if (error.validation_errors) {
						this._handleValidationErrors(error.validation_errors);
					} else if (error.error) {
						this._handleError(error.error);
					}
				}
			);
		},

		/**
		 * returs true, if a birthdate is displayable in an input of type date
		 */
		validateBirthday(address) {
			const birthdayInput = this.$refs.addressForm.querySelector("input[type=date][id*='txtBirthdate']");

			if (address.birthday) {
				// input for birthday is not active
				if (!birthdayInput) {
					const input = document.createElement("input");

					input.type = "date";
					input.value = address.birthday;

					if (input.value !== address.birthday) {
						return false;
					}
				} else if (birthdayInput.value !== address.birthday) {
					// the input's value doesn't match the addresses value
					return false;
				}
			}

			return true;
		},

		/**
		 * Create a new address
		 */
		createAddress() {
			this.waiting = true;
			this._syncOptionTypesAddressData();

            const theRefs = this.$root.$refs;

			this.$store.dispatch("createAddress", { address: this.addressData, addressType: this.addressType }).then(
				(response) => {
					this.addressModal.hide();
					this.waiting = false;
					if (this.$store.getters.isLoggedIn) {
						const totalNrOfBillingAddresses = this.getNumberOfActiveAddresses(theRefs.invoiceAddressesSelect.querySelectorAll(".vue-recycle-scroller__item-view"));
						const totalNrOfShippingAddresses = this.getNumberOfActiveAddresses(theRefs.shippingAddressesSelect.querySelectorAll(".shipping-addresses-select .vue-recycle-scroller__item-view"));

						if (
							(this.addressType === "1" && (totalNrOfBillingAddresses === 0 || totalNrOfBillingAddresses === 1))
							||
							(this.addressType === "2" && (totalNrOfShippingAddresses === 0 || totalNrOfShippingAddresses === 1))
						) {
							const theNewSavedAddress = response;

							theNewSavedAddress.pivot.isPrimary = 1;
							this.$store.dispatch("updateAddress", {
								address: theNewSavedAddress,
								addressType: this.addressType
							})
								.then(() => {
									if (this.addressType === "1") {
										theRefs.pageContent.setAttribute("data-nrOfBillingAddresses", "1");
									} else if (this.addressType === "2") {
										theRefs.pageContent.setAttribute("data-nrOfDeliveryAddresses", "1");
									}
								});
						}
					}
				},
				error => {
					this.waiting = false;

					if (error.validation_errors) {
						this._handleValidationErrors(error.validation_errors);
					} else if (error.error) {
						this._handleError(error.error);
					}
				}
			);
		},

		_handleValidationErrors(validationErrors) {
			ValidationService.markFailedValidationFields(this.$refs.addressForm, validationErrors);

			let errorMessage = "";

			for (const value of Object.values(validationErrors)) {
				errorMessage += value + "<br>";
			}

			NotificationService.error(errorMessage);
		},

		_handleError(error) {
			if (error.code === 11) {
				NotificationService.error({ code: error.code, message: "" });
				window.location.reload();
			} else if ([210, 211].indexOf(error.code) !== -1) {
				NotificationService.error({ code: error.code, message: error.message });
			} else {
				this._handleValidationErrors(error);
			}
		},

		_syncOptionTypesAddressData() {
			if (typeof this.addressData.options !== "undefined") {
				for (const optionType of this.addressData.options) {
					/* eslint-disable default-case */
					switch (optionType.typeId) {
						case 1: {
							if (
								!isNullOrUndefined(this.addressData.vatNumber) &&
								this.addressData.vatNumber !== optionType.value
							) {
								optionType.value = this.addressData.vatNumber;
							}

							break;
						}
						case 4: {
							if (
								!isNullOrUndefined(this.addressData.telephone) &&
								this.addressData.telephone !== optionType.value
							) {
								optionType.value = this.addressData.telephone;
							}
							break;
						}
						case 5: {
							if (
								!isNullOrUndefined(this.addressData.email) &&
								this.addressData.email !== optionType.value
							) {
								optionType.value = this.addressData.email;
							}
							break;
						}
						case 6: {
							if (
								!isNullOrUndefined(this.addressData.postNumber) &&
								this.addressData.postNumber !== optionType.value
							) {
								optionType.value = this.addressData.postNumber;
							}
							break;
						}
						case 9: {
							if (
								!isNullOrUndefined(this.addressData.birthday) &&
								this.addressData.birthday !== optionType.value
							) {
								optionType.value = this.addressData.birthday;
							}
							break;
						}
						case 11: {
							if (
								!isNullOrUndefined(this.addressData.title) &&
								this.addressData.title !== optionType.value
							) {
								optionType.value = this.addressData.title;
							}
							break;
						}
						case 12: {
							if (
								!isNullOrUndefined(this.addressData.contactPerson) &&
								this.addressData.contactPerson !== optionType.value
							) {
								optionType.value = this.addressData.contactPerson;
							}
							break;
						}
					}
				}
			}
		},

		emitInputEvent(event) {
			this.$emit("input", event);

			this.checkInputEventForUnmarkFields(event);
		},

		checkInputEventForUnmarkFields(event) {
			const genderCondition = event.field === "gender" && event.field.value !== this.addressData.gender;
			const countryCondition = event.field === "countryId" && event.field.value !== this.addressData.countryId;
			const pickupCondition =
				event.field === "showPickupStation" && event.field.value !== this.addressData.showPickupStation;

			if (genderCondition || countryCondition || pickupCondition) {
				ValidationService.unmarkAllFields(this.$refs.addressForm);
			}
		},

		validateRegisterChange(isVisibleRegistration) {
			this.showRegisterInput = !!isVisibleRegistration;
		},

		getAddressInputGroupMethods(publicMethods) {
        	this.$options.addressInputGroupMethods = publicMethods;
		},

        getNumberOfActiveAddresses(theNodes) {
            let number = 0;

            if (theNodes.length === 0) {
                return number;
            }
            for (let con=0; con < theNodes.length; con++) {
                const style= window.getComputedStyle(theNodes[con]);
                const matrix = new DOMMatrixReadOnly(style.transform).m42;

                if (matrix >= 0) {
                    number++;
                }
            }

            return number;
        }
	}
});
